import { EventEmitter, Injectable } from '@angular/core';
import { DialogFlowResult, ListeningStatusKey } from '../data/type/audio';

@Injectable({
  providedIn: 'root',
})
export class VoiceSearchService {
  statusEvent: EventEmitter<ListeningStatusKey> = new EventEmitter();
  speechResultsEvent: EventEmitter<string> = new EventEmitter();
  dialogFlowEvent: EventEmitter<DialogFlowResult> = new EventEmitter();
  audioEndedEvent: EventEmitter<undefined> = new EventEmitter();

  triggerStatusEvent(status: ListeningStatusKey) {
    this.statusEvent.emit(status);
  }

  triggerSpeechResultsEvent(result: string) {
    this.speechResultsEvent.emit(result);
  }

  triggerDialogFlowEvent(result: DialogFlowResult) {
    this.dialogFlowEvent.emit(result);
  }

  triggerAudioEndedEvent() {
    this.audioEndedEvent.emit();
  }
}
